
import React from 'react'
import TaskCard from './TaskCard'
import EmptyState from './EmptyState'
import { useTasks } from '@/hooks/useTasks'

const MyTasksView: React.FC = () => {
  const { getMyTasks, getPriorityTasks, updateTaskStatus, loading } = useTasks()
  
  const { userTasks: myUserTasks, customTasks: myCustomTasks } = getMyTasks()
  const { userTasks: priorityUserTasks, customTasks: priorityCustomTasks } = getPriorityTasks()

  const handleTaskAction = async (taskId: string, actionType: string) => {
    if (actionType === 'priority') {
      await updateTaskStatus(taskId, 'priority')
    } else if (actionType === 'archive') {
      await updateTaskStatus(taskId, 'archived')
    }
  }

  const handleCustomTaskAction = async (taskId: string, actionType: string) => {
    if (actionType === 'priority') {
      await updateTaskStatus(taskId, 'priority', true)
    } else if (actionType === 'archive') {
      await updateTaskStatus(taskId, 'archived', true)
    }
  }

  if (loading) {
    return <div className="text-center py-8">Loading tasks...</div>
  }

  return (
    <div className="grid grid-cols-2 gap-6">
      {/* Priority Tasks */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Priority Tasks</h2>
        <div className="space-y-3">
          {priorityUserTasks.length > 0 || priorityCustomTasks.length > 0 ? (
            <>
              {priorityUserTasks.map(userTask => (
                <TaskCard 
                  key={userTask.id} 
                  task={{
                    id: userTask.id,
                    title: userTask.school_tasks.title,
                    module: userTask.school_tasks.module || undefined,
                    description: userTask.school_tasks.description || undefined,
                    priority: userTask.school_tasks.priority
                  }}
                  showArchiveButton={true}
                  onAction={handleTaskAction}
                />
              ))}
              {priorityCustomTasks.map(customTask => (
                <TaskCard 
                  key={customTask.id} 
                  task={customTask}
                  showArchiveButton={true}
                  onAction={handleCustomTaskAction}
                />
              ))}
            </>
          ) : (
            <EmptyState title="Priority Tasks" message="No priority tasks" />
          )}
        </div>
      </div>

      {/* My Tasks */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-4">My Tasks</h2>
        <div className="space-y-3">
          {myUserTasks.length > 0 || myCustomTasks.length > 0 ? (
            <>
              {myUserTasks.map(userTask => (
                <TaskCard 
                  key={userTask.id} 
                  task={{
                    id: userTask.id,
                    title: userTask.school_tasks.title,
                    module: userTask.school_tasks.module || undefined,
                    description: userTask.school_tasks.description || undefined,
                    priority: userTask.school_tasks.priority
                  }}
                  showActions={true}
                  actionType="priority"
                  showArchiveButton={true}
                  onAction={handleTaskAction}
                />
              ))}
              {myCustomTasks.map(customTask => (
                <TaskCard 
                  key={customTask.id} 
                  task={customTask}
                  showActions={true}
                  actionType="priority"
                  showArchiveButton={true}
                  onAction={handleCustomTaskAction}
                />
              ))}
            </>
          ) : (
            <EmptyState title="My Tasks" message="No Tasks Yet" />
          )}
        </div>
      </div>
    </div>
  )
}

export default MyTasksView
